export const ORGANIZATION_SETTINGS = {
  // Main navigation elements
  BACK_TO_HOME_BUTTON: 'org-settings-back-to-home-button',
  DETAILS_TAB: 'org-settings-details-tab',
  PERMISSIONS_TAB: 'org-settings-permissions-tab',
  PROJECT_VISIBILITY_TAB: 'org-settings-project-visibility-tab',
  SAML_CONFIG_TAB: 'org-settings-saml-config-tab',
  SAVE_CHANGES_BUTTON: 'org-settings-save-changes-button',
  CANCEL_BUTTON: 'org-settings-cancel-button',

  // Organization details elements
  ORG_NAME_INPUT: 'org-settings-org-name-input',
  ORG_DESCRIPTION_INPUT: 'org-settings-org-description-input',

  // Upload logo elements
  UPLOAD_LOGO_BUTTON: 'org-settings-upload-logo-button',
  CHANGE_LOGO_BUTTON: 'org-settings-change-logo-button',
  REMOVE_LOGO_BUTTON: 'org-settings-remove-logo-button',
  CROP_DIALOG_CANCEL_BUTTON: 'org-settings-crop-dialog-cancel-button',
  CROP_DIALOG_CROP_BUTTON: 'org-settings-crop-dialog-crop-button',

  // SAML configuration elements
  SAML_ENTITY_ID_COPY: 'org-settings-saml-entity-id-copy',
  SAML_SERVICE_URL_COPY: 'org-settings-saml-service-url-copy',
  SAML_HELP_LINK: 'org-settings-saml-help-link',
  SAML_FILE_RADIO: 'org-settings-saml-file-radio',
  SAML_URL_RADIO: 'org-settings-saml-url-radio',
  SAML_CHOOSE_FILE_BUTTON: 'org-settings-saml-choose-file-button',
  SAML_REMOVE_FILE_BUTTON: 'org-settings-saml-remove-file-button',
  SAML_URL_INPUT: 'org-settings-saml-url-input',
  SAML_DOMAIN_INPUT: 'org-settings-saml-domain-input',
  SAML_ENFORCE_SSO_BUTTON: 'org-settings-saml-enforce-sso-button'
} as const;
